import List from './List';
import Edit from './Edit';

export const Form = {
  List,
  Edit,
};
